import { Edit } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

const QueryInline: React.FC<{
  label: string;
  value: string | React.ReactNode;
  editable?: boolean;
  onEdit?: () => void;
}> = ({ label, value, editable = false, onEdit }) => (
    <Stack direction="row" justifyContent="space-between" sx={{
        py: 1.5,
        borderBottom: '1px solid #f1f3f5',
        '&:last-child': { borderBottom: 'none' },
        ...(editable && {
            '&:hover': {
                bgcolor: '#fafbfc',
                mx: -1.5,
                px: 1.5,
                borderRadius: 0.75,
            },
        }),
    }}>
        <Typography
            fontFamily="Lato"
            fontSize="0.9rem"
            color="#6c757d"
            textAlign="left"
            minWidth={70}>
            {label}
        </Typography>
        <Stack direction="row" alignItems="center">
            <Typography
                fontFamily="Lato"
                fontSize="0.9rem"
                color="#2c3e50"
                fontWeight={600}
                textAlign="right">
                {value}
            </Typography>
            {editable && (
                <IconButton size="small" sx={{
                    opacity: 0,
                    transition: 'opacity 0.2s',
                    '&:hover': { opacity: 1 },
                }} onClick={onEdit} disableRipple>
                    <Edit sx={{ fontSize: 14 }} />
                </IconButton>
            )}
        </Stack>
    </Stack>
);

export default QueryInline;